import React from 'react';
import './index.css';
import clsx from 'classnames';
import { Pagination } from 'components';
import QueueAnim from 'rc-queue-anim';
import { useAppContext } from 'context';
import ProductItem from '../ProductItem';

const ProductList = (props) => {
  const { currentPage, setCurrentPage, dlist, imageCacheKey } = props;

  const {
    state: { type },
  } = useAppContext();

  // 根据peoductArr数据进行数据重组已九条数据为一页，返回重组数组以及相关的页数
  const productArrList = (arr) => {
    const pageNum = Math.ceil(arr?.length / 9);
    const newArr = [];
    for (let i = 0; i < pageNum; i++) {
      newArr.push(arr.slice(i * 9, (i + 1) * 9));
    }
    return newArr;
  };

  const getProductArr = productArrList(
    type === 'new' ? dlist : dlist?.filter((v) => v.cid === type),
  );
  const typeNewProductData = getProductArr[currentPage - 1]?.map((v) => {
    return { ...v, cid: 'new' };
  });
  const productData =
    type === 'new' ? typeNewProductData : getProductArr[currentPage - 1];

  return (
    <QueueAnim
      className={clsx('product-center-content-right')}
      type={['bottom', 'top']}
    >
      <div
        className={clsx('product-center-content-right-content')}
        key='product-center-content-right-content'
      >
        {productData?.map((v, index) => {
          return (
            <ProductItem
              item={v}
              key={index}
              currentPage={currentPage}
              imageCacheKey={imageCacheKey}
            />
          );
        })}
      </div>
      {/* 底部分页 */}
      <div key='pagination'>
        {getProductArr.length > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={getProductArr.length}
            onChange={(page) => setCurrentPage(page)}
          />
        )}
      </div>
    </QueueAnim>
  );
};

export default ProductList;
